import React, {useRef, useState} from 'react';
import { connect } from 'react-redux';
import { Typography, withStyles, Tooltip, IconButton } from '@material-ui/core';
import { hasPermission } from '../sc-utilities';
import ExternalInfoList from './ExternalInfoList';
import { LinkOff } from '@material-ui/icons';
import ExternalInfoUnpaired from './ExternalInfoUnpaired';
import { snackActions } from '../sc-utilities/SnackBar';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    }
});

const ExternalInfo = props => {
    const tableRef = useRef();
    const { classes, data, onUnpairedExternal, columns, translations, activeCustomerID, permissions, onUnpairedBulkExternal, type } = props;
    let visible = columns && columns['ExternalInfo'];
    const [unpairedExternal, setUnpairedModalState] = useState({ open: false, externalInfoIDs: [], externalID: null, forBulk: false });

    const handleCloseSafe = () => {
        setUnpairedModalState({ ...unpairedExternal, open: false, externalID: null, forBulk: null, externalInfoID: null })
    };

    const handleUnpairedDialog = (externalID) => {
        setUnpairedModalState({ ...unpairedExternal, open: true, externalID: externalID, forBulk: null })
    }

    const handleCloseDanger = async () => {
        let result
        if (unpairedExternal.forBulk) {
            result = await onUnpairedBulkExternal({ data: unpairedExternal.externalInfoIDs, ActiveCustomerID: activeCustomerID });
        }
        else {
            result = await onUnpairedExternal({ data: unpairedExternal.externalID, ActiveCustomerID: activeCustomerID });
        }
        setUnpairedModalState({ ...unpairedExternal, open: false })
        if (result) {
            return snackActions.snackBarComponent(`${translations["unpaired_success"] || 'Unpaired successfully'}.`, 'success');
        }
        return snackActions.snackBarComponent(`${translations["unpaired_fail"] || 'Failed to unpaired'}`, 'error');
    };

    const handleBulkUnpaired = externalInfoIDs => {
        setUnpairedModalState({ ...unpairedExternal, open: true, externalInfoIDs: externalInfoIDs, forBulk: true });
    };

    const tableActions = [
        {
            tooltip: `${translations["unpaired_all"] || "Unpaired all selected"} ${type}`,
            icon: <LinkOff />,
            onClick: (rowData) => handleBulkUnpaired(rowData.map(externalInfo => externalInfo.PaletteExternalInfoID))
        }
    ]

    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 200, maxWidth: 200 },
            filtering: false,
            render: rowData => {
                return (<>
                    {rowData.ExternalID ?
                        <Tooltip title={translations["unpaired_product"] || "Unpaired product"}>
                            <IconButton value={rowData.ProductExternalInfoID} aria-label={translations["unpaired_product"] || "Unpaired product"} onClick={() => handleUnpairedDialog(rowData.PaletteExternalInfoID)}>
                                <LinkOff />
                            </IconButton>
                        </Tooltip> : null}
                </>
                )
            }
        },
        {
            field: 'ExternalID',
            title: translations["external_id"] || 'External ID',
            hidden: visible ? visible['ExternalID'] : false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.ExternalID ? rowData.ExternalID : translations['short_not_assigned'] || 'n/a'}</Typography>;
            },
        },
        {
            title: translations["service_type"] || "Service type", field: 'ServiceType',
            hidden: visible ? visible['ServiceType'] : false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.ExternalServiceType ? rowData.ExternalServiceType : translations['short_not_assigned'] || 'n/a'}</Typography>;
            },
        },
        {
            title: translations["data_sent"] || "Data sent", field: 'SendArticleData',
            hidden: visible ? visible['SendArticleData'] : false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.SendArticleData ? translations['ready_to_send'] || 'Ready to send' : translations['already_send'] || 'Already sent'}</Typography>;
            },
        }
    ];

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'external_system_list') ?
                <ExternalInfoList type={type} tableActions={tableActions} externalData={data} tableColumns={tableColumns} onUnpairedBulkExternal={onUnpairedBulkExternal} tableRef={tableRef} />
                : null}
            {
                hasPermission(permissions, 'unpaired_palette') ? (
                    <ExternalInfoUnpaired
                        entityName={translations['external_system_info'] || 'External system info'}
                        translations={translations}
                        handleCloseDanger={handleCloseDanger}
                        handleCloseSafe={handleCloseSafe}
                        unpairedExternal={unpairedExternal}
                    />
                ) : null
            }
        </div >
    );
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ExternalInfo));